<script>
    import { BackgroundService } from "$/services/BackgroundService";
    import { UserService } from "$/services/UserService";
    import { formattedDateAndTime } from "$/utils/date";
    import { tooltip } from "$/utils/tooltip";
    import { ServiceConsts } from "$/services/ServiceConsts";
    import { TokenStore } from "$/stores/TokenStore";

    export let workspace = null;

    let slackSyncing = false;

    let UserServiceImpl = chrome?.storage ? BackgroundService : UserService;

    const syncSlackWorkspace = async (event, workspaceId) => {
        event.preventDefault();
        slackSyncing = true;
        workspace = await UserServiceImpl.syncSlackWorkspace(workspaceId);
        slackSyncing = false;
    };
</script>

<a
    class="menu-item menu-item--pointer"
    href={workspace.url}
    target="_blank"
    rel="noreferrer"
>
    <img
        class="menu-item-icon"
        src={workspace.icon}
        alt="slack workspace icon"
    />
    <span class="menu-item-title">
        {workspace.name}
    </span>
    <div class="sidebar-list-title__button">
        <div class="flex flex-row">
            <span class="mr-2 h-4 w-4">
                {#if workspace.directMessagesActive}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        use:tooltip={"Send mentions as slack DMs - available"}
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244"
                        />
                    </svg>
                {:else}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        use:tooltip={"Send mentions as slack DMs - not available<br> Please click to install the collabwriting app on your slack to enable slack DMs"}
                        on:click={(event) =>
                            window.open(
                                ServiceConsts.SLACK_DISTRIBUTION_APP_URL +
                                    $TokenStore?.user?.id,
                            )}
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M13.181 8.68a4.503 4.503 0 0 1 1.903 6.405m-9.768-2.782L3.56 14.06a4.5 4.5 0 0 0 6.364 6.365l3.129-3.129m5.614-5.615 1.757-1.757a4.5 4.5 0 0 0-6.364-6.365l-4.5 4.5c-.258.26-.479.541-.661.84m1.903 6.405a4.495 4.495 0 0 1-1.242-.88 4.483 4.483 0 0 1-1.062-1.683m6.587 2.345 5.907 5.907m-5.907-5.907L8.898 8.898M2.991 2.99 8.898 8.9"
                        />
                    </svg>
                {/if}
            </span>
            <span
                on:click={(event) => syncSlackWorkspace(event, workspace.id)}
                on:keydown|preventDefault|stopPropagation
                on:keyup|preventDefault|stopPropagation
                on:keypress|preventDefault|stopPropagation
                class="h-4 w-4"
                use:tooltip={"Last Synced on " +
                    formattedDateAndTime(workspace.lastUpdated)}
            >
                <svg
                    class:animate-spin={slackSyncing}
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                    />
                </svg>
            </span>
        </div>
    </div>
</a>

<style>
    @import "../main.css";

    .menu-item-icon {
        @apply reset h-4 w-4 rounded-full !important;
    }

    .menu-item-title {
        @apply reset ml-2 text-sm !important;
    }

    .menu-item {
        @apply reset flex select-none flex-row items-center border-b border-solid border-gray-200 bg-white py-2 pl-4 pr-2 text-gray-800 no-underline hover:bg-gray-100 !important;
    }

    .menu-item--pointer {
        @apply cursor-pointer !important;
    }

    .menu-item.yellow {
        @apply border-yellow-200 bg-yellow-100 text-yellow-800 hover:bg-yellow-200 !important;
    }

    .menu-item.pink {
        @apply border-pink-200 bg-pink-100 text-pink-800 hover:bg-pink-200 !important;
    }

    .menu-item-arrow {
        @apply reset ml-auto mr-2 h-4 w-4 transition-all duration-300 !important;
    }

    .menu-item:hover .menu-item-arrow {
        @apply mr-0 !important;
    }

    .sidebar-list-title__button {
        @apply ml-auto mr-2 cursor-pointer;
    }
</style>
